<template>
  <div class="main">
    <common-header></common-header>
    <div class="con">
      <router-view></router-view>
    </div>
    <div class="conBom">
      <commonFooter></commonFooter>
    </div>
    <el-backtop/>
  </div>
</template>

<script>
import commonHeader from "../components/header.vue";
import commonFooter from "../components/myFooter.vue";

export default {
  name: "index",
  components: {
    commonHeader,
    commonFooter
  },
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>

<style scoped>
.main {
  width: 100%;
}

.con {
  width: 100%;
  min-height: calc(100vh - 364px);
  /*background: #F6F6F6;*/
  background: #fff;
}

.el-backtop {
  color: #2257ab;
}
</style>
